import React from 'react'
import { Modal } from 'react-bootstrap'
import DetailDoctor from '../DetailDoctor/index'
import DetailDoctorService from '../Service/DetailDoctorService'
import PasienService from '../Service/pasienService'
// import './detaildoctor.css'

export default class formInputNew extends React.Component {

    constructor() {
        super()
        this.state = {

            // data: {
            // id_doctor: "606440dd2cec8b3624e95b2c",
            // id_doctor: "606440dd2cec8b3624e95b2d",
            // },

            bioList: []
        }
    }


    loadList = async () => {

        const responBio = await DetailDoctorService.getBiodata(this.state.data)
        if (responBio.success) {
            this.setState({
                bioList: responBio.result,
            })
            {
                this.state.bioList.map(data => {
                    this.setState({
                        image: data.image
                    })
                })
            }
        }

        const responTreat = await DetailDoctorService.getTreatment(this.state.data)
        if (responTreat.success) {
            this.setState({
                treatList: responTreat.result,
            })
        }

        const responEdu = await DetailDoctorService.getEducation(this.state.data)
        if (responEdu.success) {
            this.setState({
                eduList: responEdu.result,
            })
        }

        const responHist = await DetailDoctorService.getHistory(this.state.data)
        if (responHist.success) {
            this.setState({
                histList: responHist.result,
            })

            {
                this.state.histList.map(data => {
                    this.setState({
                        faskesList: this.state.faskesList.concat([data.faskesList])
                        // locParent: this.state.locParent.concat([data.locParent])
                    })
                })
            }
        }

        const responLoc = await DetailDoctorService.getLokasi(this.state.data)
        if (responHist.success) {
            this.setState({
                locList: responLoc.result
            })
            {
                this.state.locList.map(data => {
                    this.setState({
                        price: data.price,
                        faskesList: this.state.faskesList.concat([data.namaRS])
                        // category: data.category
                    })
                })
            }
        }
        const resSchedule = await DetailDoctorService.getJadwal(this.state.data)
        if (resSchedule.success) {
            this.setState({
                schList: resSchedule.result
            })
        }

        const resJanji = await PasienService.getAll()
        if (resJanji.success) {
            this.setState({
                relasiList: resJanji.result
            })
        }

        // const responFaskes = await DetailDoctorService.getFaskes(this.state.data)
        // if (responFaskes.success) {
        //     this.setState({
        //         faskesList: responFaskes.result,
        //     })
        // }
    }


    render() {
        const { image, changeHandler, saveHandler, Model, ShowModalJanjiNew, relasiList, bioList, treatList, locList, faskesList, faskes, List, ListCostumer_Relation, CancelHandler, errors, Mode, ListTreatment } = this.props

        return (

            <div class="mb-10">
                {/* {JSON.stringify(this.state.image)} */}
                <Modal show={ShowModalJanjiNew} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode} DOKTER New</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-12">

                            <div class="form-group row">
                                <div class="col-md-12" style={{ paddingTop: 30 }}>
                                    <div class="profile-info-left">
                                        <div class="col-md-3 float-left">
                                            <div class="profile-img">
                                                <a href="#"><img class="avatar" src={image} alt="" /></a>
                                            </div>
                                        </div>

                                        <div class="row padding-top : 20px" style={{ marginLeft: 30 }}>
                                            <div class="col-md-12">

                                                {/* <tbody>
                                                            <h3 class="text">{Model.nama_dokter}</h3>
                                                            <small class="text">{Model.spesialisasi}</small>
                                                            <div class="text">{parseInt(Model.Tyear) - parseInt(Model.Lyear)} tahun pengalaman</div>
                                                        </tbody> */}
                                                {/* {bioList.map(data => {
                                                    return (
                                                        <tbody>
                                                            <h3 class="text">{data.fullname}</h3>
                                                            <small class="text">{data.sp}</small>
                                                            <div class="text">{parseInt(data.Tyear) - parseInt(data.Lyear)} tahun pengalaman</div>
                                                        </tbody>
                                                    )
                                                })} */}

                                            </div>

                                        </div>
                                    </div>

                                    <br></br>
                                    <label for="location_level_name" class="form-label lebar formInput">Konsultasi untuk*</label>
                                    <div class="lebar">
                                        <select class="form-control fontFormInput" aria-label="Disabled select example" disabled >
                                            <option selected hidden>{Model.nama_pasien}, {Model.hubungan}</option>

                                        </select>
                                    </div>

                                    <br></br>
                                    <label for="faskes_name" class="form-label lebar formInput">Faskes*</label>
                                    <div class="lebar">
                                        <select class="form-control fontFormInput" aria-label="Disabled select example" disabled>

                                            <option selected hidden>{Model.medical_facility}</option>

                                        </select>
                                    </div>

                                    <br></br>
                                    <label for="appointment_date" class="form-label lebar formInput">Waktu Kedatangan*</label>
                                    <div class="lebar">
                                        <input type="datetime-local" class="form-control" value={Model.tanggal_datang} onChange={changeHandler("tanggal_datang")} />
                                        <span class="error">{errors["tanggal_datang"]}</span>
                                    </div>


                                    <br></br>
                                    <label for="location_level_name" class="form-label lebar formInput">Tindakan Medis*</label>
                                    <div class="lebar">
                                        <select class="form-control fontFormInput" >
                                            <option selected hidden>{Model.treatment}</option>

                                            {
                                                ListTreatment.map(data => {
                                                    return (
                                                        <option value={data._id}>{data.treatment}</option>
                                                    )
                                                })
                                            }
                                            <span class="error">{errors["treatment"]}</span>
                                        </select>

                                    </div>

                                </div>

                                <br></br>

                            </div>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Submit</button>
                        <button type="button" class="btn btn-primary" onClick={CancelHandler}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
